var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16594 7.10361L11.7799 10.7175C12.0734 11.0107 12.0734 11.4866 11.78 11.7799C11.6336 11.9265 11.4413 12 11.2489 12C11.0566 12 10.8642 11.9265 10.7175 11.7799L7.10351 8.16603C6.36803 8.68916 5.47113 9 4.49994 9C2.0148 9 0 6.98512 0 4.5C0 2.01488 2.0148 0 4.49994 0C6.98505 0 8.99985 2.01488 8.99983 4.5C8.99983 5.47126 8.68906 6.36824 8.16594 7.10361ZM6.64832 6.64874L6.94326 6.23401C7.30723 5.7225 7.49957 5.12287 7.49923 4.5C7.49923 2.84587 6.1535 1.5 4.49926 1.5C2.84502 1.5 1.49931 2.84587 1.49931 4.5C1.49931 6.15411 2.84502 7.5 4.49926 7.5C5.12231 7.5 5.72201 7.30762 6.23345 6.94387L6.64832 6.64874Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.cc814132d3b13b7e9582c5b2ce164fc9.svg";
export { ForwardRef as ReactComponent };